import { Injectable } from '@angular/core';
import { AdminCenterService } from '../wsp_admin_center_sdk/admin-center.service';
import { MonitorApiService } from '@vendasta/wsp-monitor';
export interface SummaryData {
  pluginUpdates: number;
  themeUpdates: number;
  coreUpdates: number;
  totalUpdates: number;
}

@Injectable({
  providedIn: 'root',
})
export class UptimeService {
  constructor(
    private adminCenterApiService: AdminCenterService,
    private monitorApiService: MonitorApiService,
  ) {}

  list(partnerId: string): any {
    return this.monitorApiService.search({ partnerId: partnerId });
  }

  getSummaryCardData(partnerId: string) {
    return this.adminCenterApiService.getPidHealthData(partnerId);
  }

  getSiteHealthChecks(siteIds) {
    return this.adminCenterApiService.getSiteHealthChecks(siteIds);
  }
}
